// ForgotPassword.js
import React, { useState } from 'react';
import "./CSS/Local.css";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';

const ForgotPassword = () => {
    let navigate = useNavigate()

    const [data, setData] = useState({
        email: "",
    });
    const [formData, setFormData] = useState({
        password: '',
        confirm_password: ""
    });
    const [otp, setOtp] = useState(Array(6).fill(''));

    const showModal = () => {
        document.getElementById('otpModal').style.display = 'block';
    };

    const closeModal = () => {
        document.getElementById('otpModal').style.display = 'none';
    };


    const showModal1 = () => {
        document.getElementById('otpModal1').style.display = 'block';
    };

    const closeModal1 = () => {
        document.getElementById('otpModal1').style.display = 'none';
    };

    const handleInputChange = (e, index) => {
        const { value } = e.target;
        if (/^[0-9]?$/.test(value)) {
            const updatedOtp = [...otp];
            updatedOtp[index] = value;
            setOtp(updatedOtp);

            // Move focus to the next input if a digit was entered
            if (value && index < otp.length - 1) {
                document.getElementById(`otp-input-${index + 1}`).focus();
            }
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            const updatedOtp = [...otp];
            updatedOtp[index] = "";
            setOtp(updatedOtp);
            document.getElementById(`otp-input-${index - 1}`).focus();
        }
    };

    // Handle paste event
    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("text");
        const pasteValues = pasteData.slice(0, otp.length).split("");
        const updatedOtp = [...otp];

        pasteValues.forEach((digit, index) => {
            if (/^[0-9]$/.test(digit)) {
                updatedOtp[index] = digit;
            }
        });

        setOtp(updatedOtp);
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };


    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };


    


    const verifyOtp = async (e) => {
        e.preventDefault();
        try {
            const enteredOtp = otp.join(''); // Combine array to get full OTP
            const response = await axios.post("https://100billionrealestate.com/user-register/api/verifyreset-otp", {
                email: data.email,

                otp: enteredOtp
            });

            if (response.data.success) {
                // if (logintoadmission === "false") {
                //   navigate('/admission');
                //   localStorage.setItem("login", JSON.stringify(response.data.newUser));
                //   localStorage.removeItem("mainhometutorila");
                //   closeModal();
                // } else {
                //   localStorage.setItem("login", JSON.stringify(response.data.newUser));
                //   navigate("/");
                //   closeModal();
                // }
                closeModal();
                showModal1();
                toast.success('Otp verified successfully');
            }
        } catch (error) {
            console.log(error);
            toast.error(`${error}`);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://100billionrealestate.com/user-register/api/resetsend-otp', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email: data.email,
                }),
            });

            if (response.ok) {
                console.log('Form submitted successfully');
                showModal();
                toast.success('Otp sent successfully');
            } else {
                console.log('Error submitting form');
                // alert(response.data.message);
                toast.error(`Internal Server Error`);
            }
        } catch (error) {
            toast.error(`${error}`);
            console.error("Sign-Up Error:", error);
        }
    }

    const PasswordChange=async(e)=>{
        e.preventDefault();
        if(formData.password !== formData.confirm_password){
            toast.error('Password does not match');
        }else{
            try {
                const response = await fetch('https://100billionrealestate.com/user-register/api/reset-password', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        email: data.email,
                        newPassword: formData.password,
                    }),
                });
    
                if (response.ok) {
                    console.log('Form submitted successfully');
                    closeModal1();
                    toast.success('Password changed successfully');
                    navigate('/login')
                } else {
                    console.log('Error submitting form');
                    toast.error(`Internal Server Error`);
                }
            } catch (error) {
                toast.error(`${error}`);
                console.error("Sign-Up Error:", error);
            }
        }
        
    }

    return (
        <>
            
            <div className='form'>
                <div className="forgot-container">
                    <div className="forgot-left login-bg">
                        {/* <h1>Your Vision, <span>Our 100billion Codes</span></h1> */}
                    </div>
                    <div className="forgot-right">
                        <h2>Forgot Password</h2>
                        <p>Enter your email to reset your password</p>
                        <form className="forgot-form" onSubmit={handleSubmit}>
                            <div className="forgot-input-container">
                                <i className="fas fa-envelope forgot-left-icon"></i>
                                <input type="email" placeholder="Email"
                                name="email"
                                    value={data.email}
                                    onChange={handleChange}
                                    
                                    required />
                            </div>
                            <button className="forgot-btn" type="submit">
                                Submit
                            </button>
                        </form>
                        <div className="forgot-forgot-signup">
                            <p>Remember your password? <button onClick={() => navigate('/login')}>Login</button></p>
                        </div>
                    </div>
                </div>
                <div id="otpModal" className="modal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <span className="modal-close" onClick={closeModal}>&times;</span>
                        </div>
                        <div className="modal-body">
                            <h2>Verify OTP</h2>
                            <p className="phone-number">Email: {data.email}</p>
                            <div className="otp-container">
                                {otp.map((_, index) => (
                                    <input
                                        key={index}
                                        id={`otp-input-${index}`}
                                        type="text"
                                        className="otp-input"
                                        maxLength="1"
                                        value={otp[index]}
                                        onChange={(e) => handleInputChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        onPaste={handlePaste}
                                    />
                                ))}
                            </div>
                            {/* <p className="wrong-number">
                                <a href="#" onClick={() => alert('Change phone number functionality not implemented.')}>Wrong Email?</a>
                            </p> */}
                        </div>
                        <div className="modal-footer">
                            <button className="modal-btn" onClick={verifyOtp}>Verify</button>
                        </div>
                    </div>
                </div>
            </div>
            {/* <button style={{ color: "red" }} onClick={showModal1}>open</button> */}
            <div id="otpModal1" className="modal">
                <div className="modal-content">
                    <div className="modal-header">
                        <span className="modal-close" onClick={closeModal1}>&times;</span>
                    </div>
                    {/* <div className="form-container"> */}
                    <form onSubmit={PasswordChange}>
                        {/* <div > */}
                        {/* <div className="form-step active" id="formStep1"> */}
                        <h2>Reset Password</h2>
                        {/* <p className="phone-number">Email: {data.email}</p> */}
                        <div className='alignitematleftoms'>
                            <label style={{ textAlign: "left" }} htmlFor="name">Password</label>
                            <input
                                type="text"
                                id="name"
                                name="password"
                                value={formData.password}
                                onChange={handlePasswordChange}
                                required
                            />
                        </div>
                        <div className='alignitematleftoms'>
                            <label htmlFor="name">Confirm Password</label>
                            <input
                                type="password"
                                id="name"
                                name="confirm_password"
                                value={formData.confirm_password}
                                onChange={handlePasswordChange}
                                required
                            />
                        </div>

                        {/* </div> */}
                        <div className="modal-footer">
                            <button className="modal-btn" type='submit'>Verify</button>
                        </div>
                        {/* </div> */}
                    </form>
                    {/* </div> */}

                </div>
            </div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </>
    );
};

export default ForgotPassword;
